import type { EventContext, EventName } from "../types";
import { EVENTS } from "../core/constants";

/**
 * Pushes an ecommerce tracking event to the appropriate dataLayer and logs the payload.
 *
 * Ensures a dataLayer array exists on the target (prefer `ecomm.window` if present, otherwise the global `window`)
 * and pushes an object containing `event` and the `ecomm` payload. Also logs the pushed payload for debugging.
 *
 * @param event - The tracking event name to push
 * @param context - The event context payload; if it contains a `window` property that object's `dataLayer` will be used as the target
 */
export function pushToDataLayer(event: string, context: EventContext) {
  const targetWindow = context.window || (typeof window !== 'undefined' ? window : null);
  if (!targetWindow) return;

  const payload = Object.assign({}, context);
  delete payload.window; // delete window prop and avoid to push as payload to dayalayer

  const eventName = event.toUpperCase() as EventName;
  const eventConfig = EVENTS[eventName] as { hasEcommerce: boolean };

  targetWindow.dataLayer = targetWindow.dataLayer || [];

  if (eventConfig?.hasEcommerce) {
    targetWindow.dataLayer.push({ ecommerce: null });
    targetWindow.dataLayer.push({ event: event, ecommerce: payload });
  } else {
    targetWindow.dataLayer.push({ event: event, ...payload });
  }
}